import { useNavigate, useParams } from 'react-router-dom';
import { DecorKindSchema } from '@pomoshnik/shared';
import { ShopsList } from './ShopsList';

/**
 * Thin wrapper для маршрута `/decors/:kind/:globalId/shops` (Block 2 Phase 8).
 *
 * Читает URL params, парсит kind через Zod (fallback на 'facade' при невалидном
 * значении — самый «безопасный» дефолт для пользователя, попавшего на сломанный
 * URL: facade — самый частый kind в Block 2). Декодирует globalId verbatim P-001
 * и пробрасывает в shared-Container `<ShopsList />`.
 *
 * Per ADR-0007 — wrapper живёт рядом с Container, чтобы router.tsx остался
 * плоским списком роутов без inline-функций.
 */
export function DecorsShopsRoute() {
  const navigate = useNavigate();
  const params = useParams<{ kind: string; globalId: string }>();
  const subKind = DecorKindSchema.safeParse(params.kind).data ?? 'facade';
  // react-router-dom v7 уже декодирует path params; повторный
  // decodeURIComponent ломается на Global_ID с `%` (URIError).
  const globalId = params.globalId ?? '';
  return (
    <ShopsList
      entityKind="decor"
      subKind={subKind}
      globalId={globalId}
      onBackToCard={() => navigate(`/decors/${subKind}/${encodeURIComponent(globalId)}`)}
    />
  );
}
